import { Upload, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface ImageUploadControlsProps {
  imagePrompt: string;
  isUploading: boolean;
  isGenerating: boolean;
  onPromptChange: (value: string) => void;
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onGenerate: () => void;
}

const ImageUploadControls = ({
  imagePrompt,
  isUploading,
  isGenerating,
  onPromptChange,
  onUpload,
  onGenerate,
}: ImageUploadControlsProps) => {
  return (
    <div className="space-y-4">
      <Textarea
        placeholder="Describe the image you want to generate in detail..."
        value={imagePrompt}
        onChange={(e) => onPromptChange(e.target.value)}
        disabled={isGenerating || isUploading}
        className="min-h-[100px] resize-none w-full"
      />
      <div className="flex gap-4">
        <Input
          id="image"
          type="file"
          accept="image/*"
          onChange={onUpload}
          disabled={isUploading || isGenerating}
          className="hidden"
        />
        <Button
          type="button"
          variant="outline"
          onClick={() => document.getElementById('image')?.click()}
          disabled={isUploading || isGenerating}
          className="flex-1"
        >
          <Upload className="mr-2 h-4 w-4" />
          {isUploading ? "Uploading..." : "Upload Image"}
        </Button>
        <Button
          type="button"
          variant="outline"
          onClick={onGenerate}
          disabled={isGenerating || isUploading || !imagePrompt.trim()}
          className="flex-1"
        >
          <Wand2 className="mr-2 h-4 w-4" />
          {isGenerating ? "Generating..." : "Generate with AI"}
        </Button>
      </div>
    </div>
  );
};

export default ImageUploadControls;